import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  fetchDocumentDetails,
  closeDocumentDetails,
} from "../slices/documents/documentDetailsSlice";

export function useDocumentDetails() {
  const dispatch = useAppDispatch();
  const {
    isOpen,
    status,
    data,
    error,
    dialogTitle,
    dialogVariant,
    showHeader,
    showSpinner,
    showDetailsContent,
    emptyStateType,
  } = useAppSelector((state) => state.DocumentDetails);

  const loadDocumentDetails = useCallback(
    (file) => dispatch(fetchDocumentDetails(file)),
    [dispatch]
  );

  const closeDetails = useCallback(
    () => dispatch(closeDocumentDetails()),
    [dispatch]
  );

  return {
    state: {
      isOpen,
      status,
      data,
      error,
      dialogTitle,
      dialogVariant,
      showHeader,
      showSpinner,
      showDetailsContent,
      emptyStateType,
    },
    loadDocumentDetails,
    closeDetails,
  };
}

